import { render, staticRenderFns } from "./account-receivable.vue?vue&type=template&id=dfca308a"
import script from "./account-receivable.vue?vue&type=script&lang=js"
export * from "./account-receivable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports